import { ToggleWithSmooth } from '@resources/js/ui/Toggle'
import inViewport from '@resources/js/helpers/inViewport'

const initToggleWithSmooth = parentElement => {
	const triggerToggleElements = parentElement.querySelectorAll(
		'.js-aside-trigger-toggle'
	)

	if (!triggerToggleElements.length) return

	triggerToggleElements.forEach(toggle => {
		const targetToggleElement = toggle.nextElementSibling

		new ToggleWithSmooth(toggle, {
			target: targetToggleElement,
			transitionTime: '0.3s',
		})
	})
}

const asideElements = document.querySelectorAll('.js-aside')

asideElements.forEach(asideElement => {
	inViewport(asideElement, () => {
		initToggleWithSmooth(asideElement)
	})
})
